import React, { useEffect, useRef } from "react";
import Modal from "../common/Modal/Modal";
import MHeader from "./common/MHeader";
import MFooter from "./common/MFooter";
import { ReactComponent as CloseIcon } from "./../../resources/images/icons/modalCloseIcon.svg";
import ErrorIcon from "./Error";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import {
  setEmailString,
  setOpenModal,
  setShowToast,
} from "../../redux/reducers/downloadSlice/downloadSlice";

interface Props {
  modalId?: number | null;
  id: number;
  triggerInventory?: any;
}

export function isValidEmail(emailString: string) {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(emailString);
}

const DownloadXlsModal = ({ id, triggerInventory }: Props) => {
  const dispatch = useAppDispatch();
  const emailString: any = useAppSelector(
    (state: any) => state?.download?.emailString
  );
  const showToast: any = useAppSelector(
    (state: any) => state?.download?.showToast
  );
  const openModal: any = useAppSelector(
    (state: any) => state?.download?.openModal
  );
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (openModal && inputRef.current) {
      inputRef.current.focus();
    }
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setEmailString(e.target.value));
  };

  const handleCancelClick = () => {
    dispatch(setShowToast(false));
    dispatch(setOpenModal(false));
  };

  const handleSubmitClick = () => {
    if (!emailString?.length) {
      dispatch(setShowToast(true));
    } else if (isValidEmail(emailString)) {
      triggerInventory();
      dispatch(setOpenModal(false));
    }
  };
  console.log({ emailString });
  const Header = (
    <MHeader>
      <span
        className="mjp-modal-text-header"
        style={{
          position: "relative",
          top: "10px",
          left: "8px",
          fontWeight: 700,
          fontSize: 16,
        }}
      >
        Download Excel
      </span>
    </MHeader>
  );

  const Footer = (
    <MFooter>
      <div className="discard-draft-footer">
        <div style={{ width: "50" }}>
          <button
            className="foundit-button xls discard-cancel-button"
            onClick={handleCancelClick}
          >
            Cancel
          </button>
        </div>
        <div style={{ width: "50%" }}>
          <button
            className="foundit-button primaryButton xls"
            onClick={handleSubmitClick}
          >
            Submit
          </button>
        </div>
      </div>
    </MFooter>
  );

  return (
    <Modal
      modalId={sessionStorage.getItem("mjpKey")!}
      isOpen={false}
      onClose={() => dispatch(setOpenModal(false))}
      header={Header}
      footer={Footer}
      closeIcon={<CloseIcon />}
      width="360px"
    >
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div
          style={{
            marginBottom: "16px",
            display: "flex",
            flexDirection: "column",
            margin: "5px 0",
            alignItems: "flex-start",
            padding: "0px 10px",
          }}
        >
          <p style={{ marginBottom: "5px", fontSize: "14px", fontWeight: 500 }}>
            Please provide your official email
            <span style={{ color: "red" }}>*</span>
          </p>

          <input
            ref={inputRef}
            type="text"
            style={{
              width: "100%",
              fontSize: "14px",
              lineHeight: "20px",
              fontWeight: 400,
              height: 44,
              borderColor:
                !emailString.length ||
                (!!emailString.length && !isValidEmail(emailString))
                  ? "red"
                  : "primary",
              marginBottom: "5px",
              borderRadius: 4,
            }}
            placeholder="Add your official email"
            value={emailString}
            onChange={handleInputChange}
          />

          {showToast && !emailString?.length && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "5px",
              }}
            >
              <span style={{ marginTop: "0.3rem", marginRight: "5px" }}>
                <ErrorIcon />
              </span>
              <p style={{ color: "red", display: "inline", fontSize: "12px" }}>
                This field is required.
              </p>
            </div>
          )}

          {!!emailString?.length && !isValidEmail(emailString!) && (
            <div style={{ marginBottom: "5px" }}>
              <span style={{ marginTop: "0.3rem", marginRight: "5px" }}>
                <ErrorIcon />
              </span>
              <p style={{ color: "red", display: "inline", fontSize: "12px" }}>
                Please enter valid Email
              </p>
            </div>
          )}

          <p style={{ fontSize: "12px", textAlign: "start" }}>
            You will receive the download link via this email. This email shall
            also be linked to your foundit login.
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default React.memo(DownloadXlsModal);
